import Delegate from "//legramme.com/cdn/shop/t/78/assets/ftdomdelegate.min.js?v=167457923630348017651773307050";

export class CollectionSection extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('[data-action="collection-overlay"]');
    this.sortContainer = this.querySelector('[data-element="sort-container"]');
    this.sortWrapper = this.querySelector('[data-element="sort-wrapper"]');

    this.filtersBar = this.querySelector('.collection__filters-container');
    this.filtersForm = this.querySelector('#filters-form');
    this.filtersContainer = document.querySelector('[data-element="filters-container"]');
    this.filtersWrapper = this.querySelector('[data-element="filters-wrapper"]');
    this.buttonContainer = this.querySelector('.product__properties-buttons-container');
    this.headerCollectionLinks = this.querySelector('[data-element="header-collection-links"]');
    this.headerCollectionInputs = this.querySelectorAll('[data-element="header-collection-links"] input[name="filter-collections"]');
    this.headerCollectionAllInput = this.querySelector('[data-element="header-collection-links"] input[name="filter-collections"][value="__all__"]');
    this.footerReinsurance = document.querySelector('.footer__reinsurance');
    this.headerCollectionOffsetTop = 0;

    this.currentCurrency = window.theme.currentCurrency;

    this.videos = this.querySelectorAll('.collection__video');

    this._attachListeners();
    this._initHeaderCollectionLinks();
    this._loadFilters();
    this._checkCollectionGrid();

    let that = this;
    Pace.on('done', function () {
      if (that.videos) {
        that._initVideo();
        that._initValueFilter(that.currentCurrency); // Céline - To see on the Filter branch
        //that._revealProducts();
      }
    });
  }

  _attachListeners() {
    new Delegate(this).on('click', '[data-action="toggle-filter-menu"]', this._toggleFilterMenu.bind(this));
    new Delegate(this).on('click', '[data-action="toggle-mobile-filters"]', this._toggleMobileFilters.bind(this));
    new Delegate(this).on('click', '[data-action="toggle-mobile-sort"]', this._toggleMobileSort.bind(this));
    new Delegate(this).on('change', '.product__property-item input', this._setFilterDescription.bind(this));
    new Delegate(this).on('click', '[data-action="submit-mobile-sort"]', this._submitSort.bind(this));
    new Delegate(this).on('click', '[data-action="submit-mobile-filters"]', this._submitFilters.bind(this));
    new Delegate(this).on('click', '[data-action="reset-filters"]', this._resetFilters.bind(this));
    new Delegate(this).on('click', '[data-action="remove-selected-filter"]', this._removeSelectedFilter.bind(this));
    new Delegate(this).on('click', '[data-action="collection-overlay"]', this._closeAllCollectionElements.bind(this));
    new Delegate(this).on('change', '[data-element="header-collection-links"] input[name="filter-collections"]', this._onHeaderCollectionFilterChange.bind(this));

    let that = this;

    if (this.filtersBar) {
      window.addEventListener('scroll', that._stickyScrollBar);
    }
    if (this.headerCollectionLinks) {
      window.addEventListener('scroll', this._updateHeaderCollectionLinksState.bind(this));
      window.addEventListener('resize', this._throttle(this._setHeaderCollectionOffsetTop.bind(this), 300));
    }
    window.addEventListener('resize', that._throttle(that._setFilterContainerHeight.bind(this), 1000));
    window.addEventListener('resize', that._throttle(that._updateAllMobileFilterTitleCounts.bind(that), 300));
  }

  _initHeaderCollectionLinks() {
    if (!this.headerCollectionLinks || !this.headerCollectionInputs.length) {
      return;
    }

    this._setHeaderCollectionOffsetTop();
    this._updateHeaderCollectionLinksState();
    this._syncHeaderCollectionInputsFromFilters();
  }

  _setHeaderCollectionOffsetTop() {
    if (!this.headerCollectionLinks) {
      return;
    }

    this.headerCollectionOffsetTop = this.headerCollectionLinks.offsetTop;
  }

  _updateHeaderCollectionLinksState() {
    if (!this.headerCollectionLinks) {
      return;
    }

    const footerOffsetHeight = this.footerReinsurance ? this.footerReinsurance.offsetHeight : 0;

    if (window.scrollY >= this.headerCollectionOffsetTop && (!this.footerReinsurance || this.footerReinsurance.getBoundingClientRect().top - footerOffsetHeight >= 0)) {
      this.headerCollectionLinks.setAttribute('aria-hidden', 'false');
    } else {
      this.headerCollectionLinks.setAttribute('aria-hidden', 'true');
    }
  }

  _syncHeaderCollectionInputsFromFilters() {
    if (!this.headerCollectionInputs.length) {
      return;
    }

    const filterInputs = this.querySelectorAll('#filters-form input[name="filter-collections"]');

    if (!filterInputs.length) {
      this._syncHeaderCollectionInputsFromURL();
      return;
    }

    let hasCheckedFilter = false;
    this.headerCollectionInputs.forEach((headerInput) => {
      if (headerInput.value === '__all__') {
        return;
      }

      const matchingInput = Array.from(filterInputs).find((filterInput) => filterInput.value === headerInput.value);
      headerInput.checked = matchingInput ? matchingInput.checked : false;

      if (headerInput.checked) {
        hasCheckedFilter = true;
      }
    });

    if (this.headerCollectionAllInput) {
      this.headerCollectionAllInput.checked = !hasCheckedFilter;
    }
  }

  _syncHeaderCollectionInputsFromURL() {
    if (!this.headerCollectionInputs.length) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    const selectedCollections = urlParams.getAll('filter-collections');
    let hasCheckedFilter = false;

    this.headerCollectionInputs.forEach((headerInput) => {
      if (headerInput.value === '__all__') {
        return;
      }

      headerInput.checked = selectedCollections.includes(headerInput.value);
      if (headerInput.checked) {
        hasCheckedFilter = true;
      }
    });

    if (this.headerCollectionAllInput) {
      this.headerCollectionAllInput.checked = !hasCheckedFilter;
    }
  }

  _getHeaderCollectionCheckedValues() {
    return Array.from(this.headerCollectionInputs)
      .filter((headerInput) => headerInput.value !== '__all__' && headerInput.checked)
      .map((headerInput) => headerInput.value);
  }

  _buildSerializedFiltersFromHeaderCollections() {
    const params = new URLSearchParams();
    const checkedHeaderValues = this._getHeaderCollectionCheckedValues();
    this.filtersForm = this.querySelector('#filters-form');

    if (this.filtersForm) {
      const formData = new FormData(this.filtersForm);
      for (const [name, value] of formData.entries()) {
        if (name !== 'filter-collections') {
          params.append(name, value);
        }
      }
    } else {
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.forEach((value, name) => {
        if (name !== 'filter-collections') {
          params.append(name, value);
        }
      });
    }

    checkedHeaderValues.forEach((value) => {
      params.append('filter-collections', value);
    });

    return params.toString();
  }

  _onHeaderCollectionFilterChange(event, target) {
    if (!this.headerCollectionInputs.length || !target) {
      return;
    }

    if (target.value === '__all__' && target.checked) {
      this.headerCollectionInputs.forEach((headerInput) => {
        if (headerInput.value !== '__all__') {
          headerInput.checked = false;
        }
      });
    } else if (target.value !== '__all__' && target.checked && this.headerCollectionAllInput) {
      this.headerCollectionAllInput.checked = false;
    }

    if (this.headerCollectionAllInput) {
      const hasCheckedHeaderFilter = Array.from(this.headerCollectionInputs).some((headerInput) => {
        return headerInput.value !== '__all__' && headerInput.checked;
      });
      this.headerCollectionAllInput.checked = !hasCheckedHeaderFilter;
    }

    const formSerialized = this._buildSerializedFiltersFromHeaderCollections();
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${formSerialized ? '?' + formSerialized : ''}`;
    window.history.replaceState({ path: newUrl }, '', newUrl);
    this._filtersRequest(formSerialized, null);
  }


  /**
   * INIT VIDEO FROM IFRAME
   */

  _initVideo() {
    this.videos.forEach(function (value, index) {
      value.setAttribute('src', value.getAttribute('data-src'));
    })
  }

  /**
   * REVEAL PRODUCTS ON COLLECTION GRID
   */

  _revealProducts() {
    // reveal product items
    let productItems = document.querySelectorAll('.main .product-item');
    ScrollReveal().reveal(productItems, { interval: 100 });
  }

  /**
   * CHECK IF THE ROWS OF THE GRID CONTAINS 5 DIV ELEMENTS
   */

  _checkCollectionGrid() {
    if (this.querySelectorAll('.collection-grid-row--push-product')) {
      this.querySelectorAll('.collection-grid-row--push-product').forEach(function (value, index) {
        if (value.children.length < 5) {
          value.classList.remove('collection-grid-row--push-product')
        }
      })
    }

    if (this.querySelectorAll('.collection-grid-row--push-reverse')) {
      this.querySelectorAll('.collection-grid-row--push-reverse').forEach(function (value, index) {
        if (value.children.length < 5) {
          //value.classList.remove('collection-grid-row--push-reverse');
          if (value.querySelector('.product-item--large')) {
            value.querySelector('.product-item--large').classList.remove('product-item--large');
          }
        }
      })
    }
  }

  _initCollectionGridInteractiveElements() {
    const collectionGridContainer = this.querySelector('[data-element="collection-grid-container"]');

    if (!collectionGridContainer) {
      return;
    }

    if (typeof window.initProductItemSectionSwipers === 'function') {
      window.initProductItemSectionSwipers(collectionGridContainer);
    } else {
      window.requestAnimationFrame(() => {
        if (typeof window.initProductItemSectionSwipers === 'function') {
          window.initProductItemSectionSwipers(collectionGridContainer);
        }
      });
    }
  }

  /**
   * TOGGLE FILTER CONTAINER
   */

  _toggleMobileFilters(event, target) {
    if (event) event.preventDefault();

    let filterContainer = document.querySelector('[data-element="filters-container"]');

    if (filterContainer) {
      if (filterContainer.classList.contains('active')) {
        filterContainer.classList.remove('active');
      } else {
        filterContainer.classList.add('active');
        this._setFilterContainerHeight();
      }
    }
  }

  /**
   * AJAX LOAD FILTERS
   */

  _loadFilters() {
    if (document.querySelector('.collection__filters-differed')) {
      let template = document.querySelector('.collection__filters-differed').getAttribute('data-template');
      let that = this;
      let href = window.location.origin + window.location.pathname;
      href = href.split('?')[0];
      href = href + '?q=' + template;

      $.ajax({
        method: 'get',
        url: href,
        data: {
          view: 'filters'
        }
      }).then(function (content) {

        if (document.querySelector('.collection__filters-differed')) {
          // inject HTML
          document.querySelector('.collection__filters-differed').innerHTML = content;

          // display filterBar
          document.querySelector('.collection__filters-container').style.visibility = 'visible';

          var searchParams = new URLSearchParams(window.location.search);
          searchParams.delete('country');
          // Filtering with params URL
          that._filtersRequest(searchParams.toString());

          // Selected Input filters and associated display
          let arrayFilters = that._getURLParams();
          that._setFiltersFromURL(arrayFilters);
          that._syncHeaderCollectionInputsFromFilters();
        }
      });

    }
  }

  /**
   * INIT VALUE FILTER
   */
  _initValueFilter(currency) {
    this.filtersValue = document.querySelectorAll('#filter-menu-price .product__property-item');
    this.filtersCurrency = document.querySelector('[name="filter-currency"]');
    let that = this;

    this.filtersValue.forEach(function (value, index) {
      that.filtersValueSpan = value.querySelectorAll('.money');

      let valuePrice = "";
      let count = 0;
      let currencyDivider = currency === 'KWD' ? 1000 : 100;

      if (that.filtersValueSpan.length > 0) {

        // check if filter is less than price
        if (that.filtersValueSpan.length === 1) {
          valuePrice = '0';
          count = 1;
        }

        that.filtersValueSpan.forEach(function (valuespan) {
          count++;
          let valuePriceConv = "";

          if (valuespan.innerHTML.includes('.')) {
            valuePriceConv = Number(valuespan.innerHTML.replace(/\D/g, '')) / currencyDivider;
          } else {
            valuePriceConv = Number(valuespan.innerHTML.replace(/\D/g, ''));
          }

          if (count > 1) {
            valuePrice = valuePrice.concat(':', valuePriceConv)
          } else {
            valuePrice = valuePrice.concat(valuePriceConv)
          }

        })

        that.filterPrice = value.querySelector('[name="filter-price"]');
        that.filterPrice.setAttribute('value', valuePrice);
      }
    })

    // Selected Input filters and associated display
    let arrayFilters = this._getURLParams();
    that._setFiltersFromURL(arrayFilters);
  }


  /**
   * SET FILTERS BY URL AND ASSOCIATED DISPLAY
   */

  _setFiltersFromURL(array) {
    if (array) {
      let filtersWithValues = [];

      for (const item of array) {
        const arrayFilter = item.split('=');
        const rawName = arrayFilter[0];
        const rawValue = arrayFilter.slice(1).join('=');

        if (!rawName || rawName.indexOf('filter-') !== 0 || !rawValue) {
          continue;
        }

        const filterName = decodeURIComponent(rawName.replace(/\+/g, ' '));
        let filterParamValue = decodeURIComponent(rawValue.replace(/\+/g, ' '));

        // >>> Check checkbox selected
        // Price management
        if (filterName === 'filter-price') {
          filterParamValue = filterParamValue.replace('%3A', ':');
        }
        let inputSelected = document.querySelector('[name="' + filterName + '"][value="' + filterParamValue + '"]');
        if (inputSelected) {
          inputSelected.setAttribute("checked", "true");
        }

        // Values with linked filters and container
        let selectedFilter = new Object();
        selectedFilter.name = filterName.toString();
        selectedFilter.value = filterParamValue.toString();
        selectedFilter.ariaContainer = filterName.toString().replace('-', '-menu-');
        filtersWithValues.push(selectedFilter);
      }

      this._renderSelectedFilters(filtersWithValues);

      // >>> Add descriptions filters
      let arrContainerFilters = Array.from(document.querySelectorAll('.product__property-title-container:not([aria-controls="sort-menu"])'));

      for (const item of arrContainerFilters) {
        // Initialization descriptions mobile & desktop
        
        
        let descriptionDesktopFilter = item.nextElementSibling.querySelector('.product__property-selected-number');
        if (descriptionDesktopFilter) {
          descriptionDesktopFilter.textContent = '0';
        }

        let ariaItem = item.getAttribute('aria-controls');
        // Price management
        if (ariaItem === 'filter-menu-price') {
          let valuesPrice = [];
          let arrPricesChecked = Array.from(item.nextElementSibling.querySelectorAll('[checked = "true"]'));
          arrPricesChecked.forEach(item => valuesPrice.push(item.nextElementSibling.textContent));
          // Mobile : list values selected
          
          // Desktop : number values selected
          if (descriptionDesktopFilter) {
            descriptionDesktopFilter.innerHTML = valuesPrice.length;
            if (valuesPrice.length > 0) {
              item.classList.add('active')
            } else {
              item.classList.remove('active')
            }
          }
        } else {
          let arrValues = [];
          filtersWithValues.forEach(filter => {
            if (filter.ariaContainer === ariaItem) {
              arrValues.push(filter.value);
            }
          });
          // Mobile : list values selected
          
          // Desktop : number values selected
          if (descriptionDesktopFilter) {
            descriptionDesktopFilter.innerHTML = arrValues.length;
            // >>> Active selected filters
            if (arrValues.length > 0) {
              item.classList.add('active')
            } else {
              item.classList.remove('active')
            }
          }
        }
      }

      this._updateAllMobileFilterTitleCounts();
    }
    else {
      this._renderSelectedFilters([]);
      this._updateAllMobileFilterTitleCounts();
    }
  }

  _updateMobileFilterTitleCount(filterWrapper) {
    if (!filterWrapper) return;

    const filterTitle = filterWrapper.querySelector('.product__property-title');
    if (!filterTitle) return;

    if (!filterTitle.dataset.baseTitle) {
      filterTitle.dataset.baseTitle = filterTitle.textContent.trim();
    }

    const baseTitle = filterTitle.dataset.baseTitle;
    const checkedCount = filterWrapper.querySelectorAll('.product__property-list input[type="checkbox"]:checked').length;

    if (checkedCount > 0) {
      filterTitle.textContent = `${baseTitle} (${checkedCount})`;
    } else {
      filterTitle.textContent = baseTitle;
    }
  }

  _updateAllMobileFilterTitleCounts() {
    this.querySelectorAll('.product__property-wrapper').forEach((filterWrapper) => {
      this._updateMobileFilterTitleCount(filterWrapper);
    });
  }

  _renderSelectedFilters(filtersWithValues) {
    const selectedFiltersContainer = this.querySelector('[data-element="selected-filters"]');
    if (!selectedFiltersContainer) return;

    const selectedFiltersList = selectedFiltersContainer.querySelector('[data-element="selected-filters-list"]');

    if (!selectedFiltersList) return;

    const validFilters = filtersWithValues.filter((filter) => {
      return filter.name
        && filter.name.indexOf('filter-') === 0
        && filter.name !== 'filter-currency'
        && filter.value;
    });

    const uniqueFilters = validFilters.filter((filter, index, self) => {
      return self.findIndex((item) => item.name === filter.name && item.value === filter.value) === index;
    });

    selectedFiltersList.innerHTML = '';

    uniqueFilters.forEach((filter) => {
      const item = document.createElement('li');
      item.className = 'collection__selected-filters-item downcase text--small';

      const label = document.createElement('span');
      label.className = 'collection__selected-filters-item-label';
      label.textContent = filter.value;

      const removeButton = document.createElement('button');
      removeButton.type = 'button';
      removeButton.className = 'collection__selected-filters-item-remove';
      removeButton.setAttribute('data-action', 'remove-selected-filter');
      removeButton.setAttribute('data-name', filter.name);
      removeButton.setAttribute('data-value', filter.value);
      removeButton.setAttribute('aria-label', 'remove filter');
      removeButton.innerHTML = '&times;';

      item.appendChild(removeButton);
      item.appendChild(label);
      selectedFiltersList.appendChild(item);
    });

    if (uniqueFilters.length > 0) {
      selectedFiltersContainer.removeAttribute('hidden');
    } else {
      selectedFiltersContainer.setAttribute('hidden', 'hidden');
    }
  }
  /**
   * CLOSE FILTER CONTAINER
   */

  _closeMobileFilters() {
    let filterContainer = document.querySelector('[data-element="filters-container"]');
    if (filterContainer) {
      filterContainer.classList.remove('active');
    }
  }

  /**
   * CLOSE ALL COLLAPSED ITEMS AND OVERLAY
   */

  _closeAllCollectionElements(event, target) {
    event.preventDefault();
    CollectionSection._closeAllCollapse('data-action="toggle-filter-menu"', target);
    if (this.overlay) {
      this.overlay.classList.remove('active');
    }
  }

  /**
   * TOGGLE FILTER DROPDOWN ITEM ON MOBILE
   */

  _toggleFilterMenu(event, target) {
    let that = this;
    if (window.matchMedia("(min-width: 1024px)").matches) {
      CollectionSection._closeAllCollapse('data-action="toggle-filter-menu"', target);
      CollectionSection._toggleCollapsible(event, target);

      if (this.overlay) {
        this.overlay.classList.remove('active');
      }

      this.querySelectorAll('[data-action="toggle-filter-menu"]').forEach(function (value, index) {
        if (value.getAttribute('aria-expanded') === 'true' && that.overlay) {
          that.overlay.classList.add('active');
        }
      })

    } else {
      CollectionSection._toggleCollapsible(event, target);
    }
  }

  /**
   * SET FILTER AND SORT WRAPPERS HEIGHT
   */

  _setFilterContainerHeight() {

    let filtersWrapper = document.querySelector('[data-element="filters-wrapper"]');
    let buttonContainer = document.querySelector('.product__properties-buttons-container');

    if (window.matchMedia("(min-width: 1024px)").matches) {
      filtersWrapper.style.height = 'auto';
      this.sortWrapper.style.height = 'auto';
    } else {
      let menuHeight = 0;

      // calculate window height - button container height
      if (buttonContainer) menuHeight += buttonContainer.offsetHeight;

      if (filtersWrapper) {
        filtersWrapper.style.height = (window.innerHeight - menuHeight).toString() + 'px';
      }

      if (this.sortWrapper) {
        this.sortWrapper.style.height = (window.innerHeight - menuHeight).toString() + 'px';
      }
    }
  }

  /**
   * TOGGLE SORT WINDOW ON MOBILE
   */

  _toggleMobileSort(event, target) {

    if (this.sortContainer) {
      if (this.sortContainer.classList.contains('active')) {
        this.sortContainer.classList.remove('active');
      } else {
        this.sortContainer.classList.add('active');
        this._setFilterContainerHeight();
      }
    }
  }

  /**
   * DISPLAY FILTERS INFORMATIONS WHEN A FILTER IS SELECTED
   */

  _setFilterDescription(event, target) {
    let descriptionMobile = target.closest('.product__property-wrapper').querySelector('.product__property-selected-value');
    let descriptionDesktop = target.closest('.product__property-wrapper').querySelector('.product__property-selected-number');
    let filterWrapperDesktop = target.closest('.product__property-wrapper').querySelector('.product__property-title-container');
    let propertyWrapper = target.closest('.product__property-wrapper');

    // gestion du tri
    if (target.getAttribute('data-label')) {
      // on stock l'URL du tri pour faire une redirection si on clique sur le bouton appliquer
      this.sortUrl = target.value;
      if (descriptionMobile) {
        descriptionMobile.innerHTML = target.getAttribute('data-label');
      }
    } else {
      // gestion des filtres
      let filtersArray = [];
      let checkedValues = this.querySelectorAll('input[name="' + target.getAttribute('name') + '"]:checked');

      for (let i = 0; i < checkedValues.length; i++) {

        // gestion des prix
        if (target.getAttribute('name') === 'filter-price' || target.getAttribute('name') === 'filter-sales') {
          filtersArray.push(checkedValues[i].nextElementSibling.textContent)
        } else {
          filtersArray.push(checkedValues[i].value)
        }
      }

      // en mobile, on renseigne dans la description du filtre les élements qui ont été sélectionnés
      if (descriptionMobile) {
        if (checkedValues.length > 0) {
          descriptionMobile.innerHTML = filtersArray.join(', ')
        } else {
          descriptionMobile.innerHTML = window.theme.default_filter_text;
        }
      }

      // en desktop, on renseigne le nombre de choix sélectionnés
      if (descriptionDesktop) {
        descriptionDesktop.innerHTML = checkedValues.length;

        if (filterWrapperDesktop) {
          if (checkedValues.length > 0) {
            filterWrapperDesktop.classList.add('active')
          } else {
            filterWrapperDesktop.classList.remove('active')
          }
        }
      }

      this._updateMobileFilterTitleCount(propertyWrapper);
    }
  }

  /**
   * USE NATIVE SHOPIFY SORT METHOD WITH URL PARAMS
   */

  _submitSort(event, target) {
    event.preventDefault();

    this._toggleMobileSort();
    this._submitFilters(event, target);
  }

  /**
   * CHECK IF URL CONTAINS FILTERS AND RETURN THIS
   */

  _getURLParams() {
    if (window.location.search.length > 0) {
      let params = window.location.search;
      let searchFilters = decodeURI(params).substring(1);
      // Params list
      return searchFilters.split('&');
    }
  };

  /**
   * SERIALIZE FORM AND CALL THE ALTERNATE TEMPLATE (collection.ajax.liquid) TO RENDER COLLECTION FILTERED
   */

  _submitFilters(event, target) {
    if (event) event.preventDefault();

    // test numbers of filtersprice for reset
    let formSerialized = $(document.querySelector('#filters-form')).serialize();
    let arrayFilter = formSerialized.split('&');
    for (var i in arrayFilter) {
      if (arrayFilter[i].includes('filter-currency')) {
        formSerialized = formSerialized.replace("&".concat(arrayFilter[i]), "");
        formSerialized = formSerialized.replace(arrayFilter[i].concat("&"), "");
      }
    }

    //
    // Add URL params
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${formSerialized}`;
    window.history.replaceState({ path: newUrl }, '', newUrl);

    this._filtersRequest(formSerialized, target);
  }

  _filtersRequest(formSerialized, target) {

    let form = formSerialized.replace(/&/g, '@');

    if (target) {
      // envoi du loader
      target.classList.add('is-loading');
    }

    // appel ajax au template
    let that = this;
    let href = window.location.origin + window.location.pathname;
    let sortBy = '';

    // TODO: Revoir la mécanique du chargement de la page.

    if (window.location.search.indexOf('sort_by') > -1) {
      sortBy = this._retrieveParamValue('sort_by');
    }

    href = href.split('?')[0];

    if (sortBy !== '') {
      href += '?sort_by=' + sortBy + '&q=' + form;
    } else {
      href += '?q=' + form;
    }

    if (form == '' && typeof (target) == 'undefined') return;

    $.ajax({
      method: 'get',
      url: href,
      data: {
        view: 'ajax'
      }
    }).then(function (content) {
      //console.log(content);

      // injection de la nouvelle page
      if (document.querySelector('[data-element="collection-grid-container"]')) {
        document.querySelector('[data-element="collection-grid-container"]').innerHTML = content;
        //window.scrollTo(0, document.querySelector('[data-element="collection-grid-container"]').scrollTop);
      }

      that._initCollectionGridInteractiveElements();

      // check grid collection
      that._checkCollectionGrid();

      // reveal products
      that._revealProducts();

      // fermeture du loader et du panel
      if (window.matchMedia("(max-width: 1023px)").matches) {
        that._closeMobileFilters();
      } else {
        CollectionSection._closeAllCollapse('data-action="toggle-filter-menu"', '');

        if (that.overlay) {
          that.overlay.classList.remove('active');
        }
      }

      if (target) {
        target.classList.remove('is-loading');
      }
    });
  }

  /**
   * RESET ALL FILTERS AND RE-SUBMIT FORM
   */

  _removeSelectedFilter(event, target) {
    if (event) event.preventDefault();

    const filterName = target.getAttribute('data-name');
    const filterValue = target.getAttribute('data-value');
    if (!filterName || !filterValue) {
      return;
    }

    const filterInputs = this.querySelectorAll(`#filters-form input[name="${filterName}"]`);
    let filterInputToReset = null;

    filterInputs.forEach((input) => {
      if (input.value === filterValue) {
        filterInputToReset = input;
      }
    });

    if (!filterInputToReset) {
      return;
    }

    filterInputToReset.checked = false;
    filterInputToReset.setAttribute('checked', 'false');

    let submitButton = null;
    const filterWrapper = filterInputToReset.closest('.product__property-wrapper');
    if (filterWrapper) {
      submitButton = filterWrapper.querySelector('.product__property-footer-submit');
      this._updateMobileFilterTitleCount(filterWrapper);
    }

    this._submitFilters(event, submitButton);
  }

  _resetFilters(event, target) {
    if (event) event.preventDefault();

    let resetCurrency = "";

    let submitButton, filterWrapperDesktop;

    if (target.classList.contains('collection__content-empty-button') || target.getAttribute('data-reset-all-filters') === 'true') {
      submitButton = target
    } else {
      submitButton = target.closest('.product__property-wrapper').querySelector('.product__property-footer-submit');
      filterWrapperDesktop = target.closest('.product__property-wrapper').querySelector('.product__property-title-container');
    }

    let filtersValues = [];

    // check if target has data-name = * or ...
    if (target.getAttribute('data-name') === "*") {
      filtersValues = this.querySelectorAll('#filters-form input');
      //reset filters
      this.querySelectorAll('.product__property-selected-number').forEach(function (value, index) {
        value.innerHTML = '0';
      })

    } else {
      filtersValues = this.querySelectorAll('input[name="' + target.getAttribute('data-name') + '"]');

      //reset filters
      let filtersNumber = target.parentNode.querySelector('.product__property-selected-number');
      filtersNumber.innerHTML = '0';
    }

    // remove all filters
    for (let i = 0; i < filtersValues.length; i++) {
      filtersValues[i].checked = false;
      filtersValues[i].setAttribute('checked', 'false')
    }
    // reset filterWrapper
    if (filterWrapperDesktop) {
      filterWrapperDesktop.classList.remove('active');
    } else {
      this.querySelectorAll('.product__property-title-container').forEach(function (value, index) {
        value.classList.remove('active');
      })
    }

    this._updateAllMobileFilterTitleCounts();

    // submit filters
    this._submitFilters(event, submitButton);
  }

  /**
   * STICKY FILTERS BAR
   */

  _throttle(fn, wait) {
    let time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    }
  }

  _stickyScrollBar() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let filtersBar = document.querySelector('.collection__filters-container');
    let header = document.querySelector('header.header');
    let announcementBar = document.querySelector('.announcement-bar');
    let offset = 0;

    if (!filtersBar || !header) {
      return;
    }

    if (window.matchMedia("(max-width: 1023px)").matches && filtersBar) {
      const mobileRect = filtersBar.getBoundingClientRect();
      const headerBottom = header.offsetHeight || 0;
      const announcementBottom = announcementBar ? announcementBar.offsetHeight : 0;
      const stickyThreshold = headerBottom + announcementBottom;
      const isMobileFiltersVisible = mobileRect.top > stickyThreshold;

      if (!isMobileFiltersVisible) {
        filtersBar.classList.add('fixed');
        header.classList.add('hide-line');
      } else {
        filtersBar.classList.remove('fixed');
        header.classList.remove('hide-line');
      }

      return;
    }

    offset = header.offsetHeight;

    if (announcementBar) {
      offset += announcementBar.offsetHeight;
    }

    if (scrollTop + filtersBar.offsetTop > offset) {
      filtersBar.classList.add('fixed');
      header.classList.add('hide-line');
    } else {
      filtersBar.classList.remove('fixed');
      header.classList.remove('hide-line');
    }

  }

  _retrieveParamValue(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  //------------------------------------
  //-- Toggle collapse
  //------------------------------------
  static _toggleCollapsible(event, target) {
    event.preventDefault();
    let collapseHeader = target;
    let collapseContent = document.getElementById(collapseHeader.getAttribute('aria-controls'));
    let isOpen = collapseHeader.getAttribute('aria-expanded') === 'true';

    if (!isOpen) {
      collapseContent.style.height = collapseContent.scrollHeight + 'px';
    } else {
      collapseContent.style.height = '0';
    }

    collapseHeader.setAttribute('aria-expanded', collapseHeader.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  }

  //------------------------------------
  //-- Close all collapse
  //------------------------------------
  static _closeAllCollapse(collapseToClose, collapseTarget) {
    let collapse = document.querySelectorAll("[" + collapseToClose + "]");

    // Loop through element and close all except target
    for (let i = 0; i < collapse.length; i++) {
      if (collapse[i] !== collapseTarget) {
        let collapseToClose = document.getElementById(collapse[i].getAttribute('aria-controls'));
        collapse[i].setAttribute('aria-expanded', 'false');
        collapseToClose.style.height = '0';
      }
    }
  }

}
try {
  window.customElements.define('collection-section', CollectionSection);
} catch (e) { }
